import React, { useMemo, useState } from 'react';
import { useTable, useFilters, usePagination, useSortBy } from 'react-table';
import columns from './Columns';
import './RiskTable.css'; // Import the CSS file


import SortDown from "../../assets/images/sortdown.svg";
import SortUp from "../../assets/images/sortup.svg";



const IncidentsTable = ({ data, openpopup }) => {
    const [filterInput, setFilterInput] = useState({
        Department: '',
        Owner: '',
        Status: ''
    });

    const defaultColumn = React.useMemo(
        () => ({
            Filter: ''
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        //page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        //pageCount,
        //gotoPage,
        nextPage,
        previousPage,
        //setPageSize,
        setFilter,
        page,
        setPageSize,
        pageSize,
        pageCount,
        gotoPage,
        state: { pageIndex }
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            initialState: { pageIndex: 0 }
        },
        useFilters,
        useSortBy,
        usePagination,
    );



    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(pageCount);

    React.useEffect(() => {
        setTotalPages(pageCount);
        setCurrentPage(pageIndex + 1);
    }, [pageCount, pageIndex]);




    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            ////console.log(newPage);
            setCurrentPage(newPage);
            gotoPage(newPage - 1);
        }
    };


    return (
        <div className="table-container2">
            {/* Render table headers only once */}
            <table {...getTableProps()} className="main-table2">
            <thead style={{ height: '77px' }}>
                    {headerGroups.map(headerGroup => (
                       <tr {...headerGroup.getHeaderGroupProps()}>
                       {headerGroup.headers.map(column => {
                           if (column.dontshow) { return null }

                           return (
                               <th {...column.getHeaderProps(column.getSortByToggleProps())} className="cursor-pointer"
                               >
                                   <div className="flex items-center">
                                       {column.render('Header')}
                                       <span>
                                           {column.isSorted
                                               ? column.isSortedDesc
                                                   ? <img src={SortDown} alt="Sort Down" className="w-4 h-4 ml-1" />
                                                   : <img src={SortUp} alt="Sort Up" className="w-4 h-4 ml-1" />
                                               : ''}
                                       </span>
                                   </div>
                               </th>
                           )
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row);
                        return (
                            <tr key={row.id} {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    //s////console.log(cell.column.dontshow)
                                    if (cell.column.dontshow) { return null }

                                    return (
                                        <td onClick={() => openpopup(cell.row.original)} {...cell.getCellProps()} className="td2 overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer">{cell.render('Cell')}</td>
                                    )
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className="pagination flex justify-between text-[#3b3b3b] p-1">
                <div className="flex items-center">
                    <button onClick={() => { handlePageChange(1) }} disabled={currentPage === 1}>
                        <i className="fa fa-angle-double-left"></i>
                    </button>
                    <button className="ml-2 mr-2" onClick={() => { handlePageChange(currentPage - 1); }} disabled={currentPage === 1}>
                        <i className="fa fa-angle-left"></i>
                    </button>
                    <span>
                        Page <strong>{currentPage}</strong> of <strong>{totalPages || 1}</strong>
                    </span>
                    <button className="ml-2" onClick={() => { handlePageChange(currentPage + 1); }} disabled={currentPage === totalPages}>
                        <i className="fa fa-angle-right"></i>
                    </button>
                    <button className="ml-2" onClick={() => { handlePageChange(totalPages); }} disabled={currentPage === totalPages}>
                        <i className="fa fa-angle-double-right"></i>
                    </button>

                    <span className='ml-2'></span>
                    <label>
                        Page Size:
                        <select value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); }}>
                            {[5, 10, 20, 30, 40, 50].map(size =>
                            (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            )
                            )}
                        </select>
                    </label>

                    {/* <span className="ml-2">
                        | Go to page:{' '}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                            }}
                            className='border border-[#3b3b3b] rounded-md p-1 w-10'
                        />
                    </span> */}
                </div>
                {/*<div className="flex items-center">
                    <select
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value));
                        }}
                        className='border border-[#3b3b3b] rounded-md p-1 w-100'
                    >
                        {[5, 10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </div>*/}
            </div>

            
        </div>
    );



};

export default IncidentsTable;